import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteText from '../../../SatelliteText/SatelliteText';
import satelliteIcon from '../../../satelliteIcon';

const SignsCustomSoftware4 = props => (
    <ServiceSection noPadBottom noPadTitle singleTitle icon={satelliteIcon} {...props} page="signsCustomSoftware" section="whenStandard">
        <div className='TextGroup Satellite'>
            <div className='container-custom subtitle'>
                <SatelliteText t={props.t} prefix="signsCustomSoftware:whenStandard" first noPadBottom />
            </div>
        </div>
    </ServiceSection>
);

export default SignsCustomSoftware4;
